import React, { useContext } from 'react';
import emptyMediaLibrary from '../../../assets/images/emptyMediaLibrary.svg';
import noContentBox from 'assets/images/no-content-box.svg';
import { IconsEnum } from '../../../constants/icons';
import { EmptyPlaceholder } from '../../../components/containers/EmptyPlaceholder';
import { BeaconContext } from '../../../providers/BeaconProvider';

export type MediaLibraryEmptyPlaceholderProps = {
  buttonAction: VoidFunction;
  hasFilters: boolean;
};
export const MediaLibraryEmptyPlaceholder = (props: MediaLibraryEmptyPlaceholderProps): JSX.Element => {
  const { buttonAction, hasFilters } = props;
  const { beacon } = useContext(BeaconContext);
  return hasFilters ? (
    <EmptyPlaceholder title={'No media found'} image={noContentBox}>
      <div>Try changing your filters</div>
    </EmptyPlaceholder>
  ) : (
    <EmptyPlaceholder
      title={'Your media library is empty'}
      image={emptyMediaLibrary}
      buttonTitle={'Add your first Media'}
      buttonAction={buttonAction}
      buttonIcon={IconsEnum.plus}>
      <div><p>Keep all your media assets in one place for easy access when creating posts. Upload your own images, GIFs, and videos, or find high-quality visuals from Unsplash, Pixabay, and Giphy. You can even use Canva to create new images with AI, or access your existing designs - all without leaving SmarterQueue!<br />
        <a onClick={() => beacon('article', '681', { type: 'modal' })}>Learn more</a></p>
      </div>
    </EmptyPlaceholder>
  );
};
